<template>
    <div>
        <transition-group
        appear
        name="v-fade"
        tag="ul"
        class="flexBlocks flexBlocks_2up flexBlocks_3upMD flexBlocks_4upLG flexBlocks_flush"
        >
            <li v-for="(item, index) in items" :key="index">
                <drawer :index="index" :item="item" v-on:toggle-drawer="toggleActiveItem" :activeItem="activeItem" :parentDimensions="parentDimensions" :previewText="previewText" :ref="'drawer_' + index"></drawer>
            </li>
        </transition-group>
    </div>
</template>
<script>
import Drawer from 'components/list/Drawer.vue';

import scrollIt from '../../utilities/smoothScroll';

export default {
  props: ['items','previewText'],
  components: {
      Drawer,
  },
  data() {
      return {
          activeItem: null,
          containerWidth: 'auto',
          parentDimensions: {
              containerWidth: 'auto',
              containerOffsetLeft: null
          },

      }
  },
  mounted() {
      this.calculateContainerValues();
  },
  watch: {
      items: function() {
          this.activeItem = null;
      },
      '$root.windowWidth': function() {
          this.calculateContainerValues();
      }
  },
  beforeDestroy() {
      window.removeEventListener('resize', this.calculateContainerValues);
    },
  methods: {
    toggleActiveItem(index, closeOnly) {
        if(this.activeItem == index || closeOnly) {
            this.activeItem = null;
            return;
        }

        this.activeItem = index;

        this.scrollWindowToDrawer(index);
    },
    calculateContainerValues() {
        this.parentDimensions.containerWidth = this.$el.offsetWidth + 'px';
        this.parentDimensions.containerOffsetLeft = this.$el.offsetLeft;
        this.activeItem = null;
    },
    scrollWindowToDrawer(index) {
        
        setTimeout(() => {

            /* this would work except Edge has a documented bug with window.scroll with smooth option */
            // const docTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            // const drawerRect = this.$refs['drawer_' + index][0].$el.getBoundingClientRect()
            // console.log("drawerRect", drawerRect);
            // console.log("doctop", docTop);
            // console.log("ScrollTo", docTop + drawerRect.top + 150);
            // window.scrollTo(0,docTop + drawerRect.top + 150) // works in ie, not smooth
            // let top = docTop + drawerRect.top + 150;
            // window.scroll({
            //     top,
            //     behavior: 'smooth'
            // });

            scrollIt(this.$refs['drawer_' + index][0].$el, 500, 'easeInOutCubic');


        },500);
    }
  }

};
</script>

<style lang="scss">

</style>

